import { InvoiceHeaderText } from 'components/InvoiceCard/styles';
import { InvoiceInterface } from 'constants/invoice';
import React from 'react';

import { InvoiceNominativeMonth } from './styles';

interface InvoiceNominateSuffixInterface {
  suffix: string;
  month: string;
  prefix: string;
}

export const InvoiceNominateLogic = (
  data: InvoiceInterface | undefined
): InvoiceNominateSuffixInterface | null => {
  if (!data?.id) return null;

  const month = data.invoiceMonth;

  let suffix = '';
  let prefix = '';

  if (data.paid) {
    prefix = 'Sua fatura de';
    suffix = 'está paga';
  } else if (data?.statusMapped === 0) {
    prefix = 'Sua fatura de';
    suffix = 'fechou';
  } else if (data?.statusMapped === 1) {
    prefix = 'Fatura de';
    suffix = 'em aberto';
  }

  return {
    suffix,
    month,
    prefix
  };
};

const InvoiceNominateMonth: React.FC<{
  data: InvoiceInterface | undefined;
}> = ({ data }) => {
  const invoiceNominateLogic = InvoiceNominateLogic(data);

  const invoiceMonth = (
    <InvoiceNominativeMonth>
      {invoiceNominateLogic?.month}
    </InvoiceNominativeMonth>
  );

  if (!invoiceNominateLogic) {
    return <></>;
  }

  return (
    <InvoiceHeaderText testID="invoiceHeaderText">
      {invoiceNominateLogic?.prefix} {invoiceMonth}{' '}
      {invoiceNominateLogic?.suffix}
    </InvoiceHeaderText>
  );
};

export default InvoiceNominateMonth;
